import styled from "@emotion/styled";

export const Content = styled.div`
  & h1 {
    font-size: 4rem;
    font-weight: 600;
  }

  & h2 {
    font-size: 2rem;
    font-weight: 500;

    margin-top: 5rem;

    &:first-child {
      margin-top: 0;
    }
  }

  & h3 {
    font-size: 1.5rem;
    font-weight: 500;
  }

  & p,
  & li {
    font-size: 1.5rem;
  }

  & p,
  & li,
  & h4 {
    line-height: 175%;
  }

  & ul {
    margin-bottom: 2.625rem;
  }

  & strong {
    font-weight: 500;
  }

  & a:hover {
    opacity: 0.8;
  }
`;
